import React from 'react'
import { createComponent } from '@ycos/fela'
import { getFontStyles } from '@ycos/primitives'

const sharedStyles = ({ theme }) => ({
  ...getFontStyles(theme.typography, { type: 'Label', name: '7' }),
  margin: 'auto',
  textAlign: 'center',
  color: theme.typography.colors.PrimaryWhite,
  textTransform: 'uppercase'
})

const Wrapper = createComponent('Wrapper', () => ({
    display: 'flex',
    flexDirection: 'column'
}))

const LoyaltyHeadingPreTitle = createComponent('LoyaltyHeadingPreTitle', ({ theme }) => {
  const { custom } = theme;
  return {
    ...sharedStyles({ theme }),
    fontFamily: theme.custom.loyaltyHero.preTitle.fontFamily,
    fontSize: theme.custom.loyaltyHero.preTitle.fontSizeSmall,
    lineHeight: custom.loyaltyHero.preTitle.lineHeightSmall,
    fontWeight: custom.loyaltyHero.preTitle.fontWeight,
    'screen-medium': {
      fontSize: custom.loyaltyHero.preTitle.fontSizeMedium,
      lineHeight: custom.loyaltyHero.preTitle.lineHeightMedium
    }
  }
})

const LoyaltyHeadingTitle = createComponent('LoyaltyHeadingTitle', ({ theme }) => ({
  ...sharedStyles({ theme }),
  fontFamily: theme.custom.loyaltyHero.title.fontFamily,
  fontSize: theme.custom.loyaltyHero.title.fontSizeSmall,
  lineHeight: theme.custom.loyaltyHero.title.lineHeightSmall,
  width: theme.custom.loyaltyHero.title.widthSmall,
  paddingBottom: `${8 * theme.spacingMultiplier}px`,
  paddingTop: `${theme.spacingMultiplier}px`,
  fontWeight: theme.custom.loyaltyHero.title.fontWeight,
  'screen-medium': {
    fontSize: theme.custom.loyaltyHero.title.fontSizeMedium,
    lineHeight: theme.custom.loyaltyHero.title.lineHeightMedium,
    width: theme.custom.loyaltyHero.title.widthMedium,
    paddingTop: `${2 * theme.spacingMultiplier}px`,
    paddingBottom: `${10 * theme.spacingMultiplier}px`
  }
}))

const LoyaltyHeadingText = createComponent('LoyaltyHeadingText', ({ theme }) => {
  const { type, name } = theme.custom.loyaltyHero.textStyles
  return {
    ...getFontStyles(theme.typography, { type, name }),
    lineHeight: theme.custom.loyaltyHero.textStyles.lineHeight,
    color: theme.typography.colors.PrimaryWhite,
    margin: 'auto',
    'screen-medium': {
      lineHeightDesktop: theme.custom.loyaltyHero.textStyles.lineHeightDesktop,
    }
  }
})

export const NewLoyaltyHeadingComponent = ({ teaserTitle, preTitle, teaserText, theme }) => {
  return (
    <Wrapper>
      <LoyaltyHeadingPreTitle theme={theme}>{preTitle}</LoyaltyHeadingPreTitle>
      <LoyaltyHeadingTitle theme={theme}>{teaserTitle}</LoyaltyHeadingTitle>
      <LoyaltyHeadingText theme={theme}>{teaserText}</LoyaltyHeadingText>
    </Wrapper>
  )
}